<div class="history-not-found">
    <img src="../../../../assets/icons/history-not-found-icon.svg" alt="" />
    <p>You have no history to display. Get started on the Inputs page</p>
</div>
